enum LoginStatus {
  CONNECTED = 'connected',
  AUTHORIZATION_EXPIRED = 'authorization_expired',
  NOT_AUTHORIZED = 'not_authorized',
  UNKNOWN = 'unknown',
}

export default LoginStatus;
